import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

import { NotificationContext } from '../context/NotificationContext';

// Banner asking the user to allow Windows/OS notifications.
// Permission must be requested from a click — browsers ignore/block requests made without a user gesture.
export default function DesktopNotificationPrompt({ compact = false }) {
  const { desktopPermission, requestDesktopPermission, showTestNotification } = useContext(NotificationContext);

  if (compact && (desktopPermission === 'unsupported' || desktopPermission === 'granted')) return null;

  const content = {
    default: {
      bg: '#fff8e1',
      text: 'เปิดการแจ้งเตือนบนหน้าจอ เพื่อไม่พลาด Draft ใหม่แม้ไม่ได้เปิดหน้านี้อยู่',
      action: { label: 'เปิดใช้งาน', onClick: requestDesktopPermission },
    },
    denied: {
      bg: '#f5f5f5',
      text: 'การแจ้งเตือนบนหน้าจอถูกบล็อก — เปิดได้ที่ไอคอนแม่กุญแจข้าง URL > การแจ้งเตือน > อนุญาต',
    },
    granted: {
      bg: '#e8f5e9',
      text: 'เปิดการแจ้งเตือนบนหน้าจอแล้ว',
      action: { label: 'ทดสอบการแจ้งเตือน', onClick: showTestNotification, variant: 'outlined' },
    },
    unsupported: {
      bg: '#f5f5f5',
      text: 'browser นี้ใช้การแจ้งเตือนบนหน้าจอไม่ได้ — ต้องเข้าผ่าน https (หรือ localhost) ด้วย Chrome / Edge บนคอมพิวเตอร์',
    },
  }[desktopPermission];

  if (!content) return null;

  return (
    <>
      <Box
        sx={{
          px: 2,
          py: compact ? 1 : 1.5,
          bgcolor: content.bg,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexShrink: 0,
          borderRadius: compact ? 0 : 2,
        }}
      >
        <Typography variant={compact ? 'caption' : 'body2'} sx={{ flex: 1, lineHeight: 1.4 }}>
          {content.text}
        </Typography>
        {content.action && (
          <Button
            size="small"
            variant={content.action.variant || 'contained'}
            onClick={content.action.onClick}
            sx={{ textTransform: 'none', whiteSpace: 'nowrap', fontSize: '0.75rem' }}
          >
            {content.action.label}
          </Button>
        )}
      </Box>
      {compact && <Divider />}
    </>
  );
}
